import { render, staticRenderFns } from "./SafeSkuList.vue?vue&type=template&id=43bf728f&scoped=true&"
import script from "./SafeSkuList.vue?vue&type=script&lang=js&"
export * from "./SafeSkuList.vue?vue&type=script&lang=js&"
import style0 from "./SafeSkuList.vue?vue&type=style&index=0&id=43bf728f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf728f",
  null
  
)

export default component.exports